import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { estimateConsumptionByHouseTypeReducer } from './api-state/estimate-consumption-by-house.reducer';
import { commonUiSalesSelectorKey } from './api-state/estimate-consumption-by-house.selector';

@NgModule({
  imports: [
    StoreModule.forFeature(commonUiSalesSelectorKey, [
      estimateConsumptionByHouseTypeReducer,
    ]),
  ],
})
export class CommonUiSalesModule {}
